import { HashLink as Link } from "react-router-hash-link";
import { FaLinkedin, FaInstagram, FaFacebookSquare } from "react-icons/fa";
import scrollToTop from "../components/scrollToTop";

const Footer = () => {
  const scrollWithOffset = (el) => {
    const vw = window.innerWidth;
    let yOffset;
    if (vw <= 1024) {
      yOffset = -96;
    } else {
      yOffset = -160;
    }

    const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <footer>
      <div className="footer-top-row">
        <Link to="/" id="footer-logo-link" onClick={scrollToTop}>
          <div className="img-container">
            <img
              src="https://d3ca8k3fzbwwwf.cloudfront.net/AHZfullwhite.webp"
              alt="Away home zone white logo"
            />
          </div>
        </Link>

        <div className="text-section">
          <h4>browse</h4>
          <Link to="/" className="footer-link" onClick={scrollToTop}>
            Home
          </Link>
          <Link to="/about" className="footer-link" onClick={scrollToTop}>
            About
          </Link>
        </div>
        <div className="text-section">
          <h4>useful links</h4>
          <Link
            to="/about#what-we-offer"
            className="footer-link"
            scroll={scrollWithOffset}
          >
            What we offer
          </Link>
          <Link
            to="/#make-an-inquiry"
            className="footer-link"
            scroll={scrollWithOffset}
          >
            Make an enquiry
          </Link>
        </div>
        <div className="text-section">
          <h4>get in touch</h4>
          <Link to="/contact" className="footer-link" onClick={scrollToTop}>
            Contact us
          </Link>
          <div className="footer-icons-container">
            <Link to="https://www.linkedin.com/company/106850996/admin/dashboard/">
              <FaLinkedin className="footer-icon" />
            </Link>
            <Link to="https://www.instagram.com/awayhomezone/?igsh=MTJ6bTh5bWNkZmplOA%3D%3D#">
              <FaInstagram className="footer-icon" />
            </Link>
            <Link to="https://www.facebook.com/people/Away-Homezone/pfbid0Dk2FY4ctP3nYiFjMp8KNMCjGipJ1YbTKdqmZ1VydFNHL2Cvt4hJ1dZZjUJFyNaCNl/">
              <FaFacebookSquare className="footer-icon" />
            </Link>
          </div>
        </div>
      </div>
      <hr />
      <span>
        ©2025 Away Home Zone - Powered by
        <Link to="https://acrylicwebstudios.com/"> Acrylic Web Studios</Link> -
        All rights reserved
      </span>
    </footer>
  );
};

export default Footer;
